import { render, staticRenderFns } from "./myhelp.vue?vue&type=template&id=10208e88&scoped=true"
import script from "./myhelp.vue?vue&type=script&lang=js"
export * from "./myhelp.vue?vue&type=script&lang=js"
import style0 from "./myhelp.vue?vue&type=style&index=0&id=10208e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10208e88",
  null
  
)

export default component.exports